/** Created by azhou on 2019/3/8.*/
<template>
    <div>
      <!--门店信息-->
      <div v-if="HStore===1">
        <!-- <div class="d-center-start mb-3">
          <left-text required leftText="负责人数" />
          <el-popover placement="right" trigger="hover">
            <div v-for="(v,ind) in BasicInfo.user_arr" :key="ind">
              <i class="iconfont icon-weixin1 mr-1" :class="[v.wechat_openid ? 'text-success' : 'text-muted']"></i>
              <span class="mr-2">{{v.truename}}</span><span class="mr-2">{{v.name}}</span>
              <span class="mr-2">{{v.mobile}}</span>
            </div>
            <span slot="reference" class="text-link">{{BasicInfo.user_arr&&BasicInfo.user_arr.length}}人</span>
          </el-popover>
        </div> -->
        <div class="d-center-between mb-3">
          <div class="w-50  d-center-start">
            <left-text required leftText="开业时间" />
            <el-date-picker size="small" class="w-100" v-model="BasicInfo.startdate" type="month" placeholder="选择开业时间" />
          </div>
          <div class="w-50 ml-2 d-center-start">
            <left-text required leftText="最近装修" />
            <el-date-picker size="small" class="w-100" v-model="BasicInfo.fitmentdate" type="month" placeholder="选择装修时间" />
          </div>
        </div>
        <div class="d-center-between mb-3">
            <left-text-border-many class="w-50 mb-2"
                :leftText="'前台/总机'"
                v-model.trim="BasicInfo.hotel_tel"
                placeholder="例如：0571-123456"
                required
                />  
            <left-text-border class="w-50 ml-2 input-just" leftText="传真号码" v-model="BasicInfo.hotel_fax"/>    
        </div>
        <!-- <div class="d-center-between mb-3">
          <left-text-border class="w-50 mr-2 input-just" leftText="前台/总机" v-model="BasicInfo.hotel_tel"/>
          <left-text-border class="w-50 mr-2 input-just" leftText="传真号码" v-model="BasicInfo.hotel_fax"/>
          <left-text-border class="w-50 ml-2 input-just" style="opacity: 0;"/>
        </div> -->
        <!-- <div class="d-center-between mb-3">
          <left-text-border class="w-50 mr-2 input-just" leftText="官方网站" v-model="BasicInfo.homepage"/>
          <left-text-border class="w-50 ml-2 input-just" style="opacity: 0;"/>
        </div> -->
        <!-- <div class="d-center-start mb-3" v-for="parentItem in breakfast" :key="parentItem.leftText">
          <left-text required :leftText="parentItem.leftText"/>
          <el-radio-group v-model="BasicInfo[parentItem.value]" class="lisdq">
            <el-radio :label="item.id" v-for="item in $GVAR[parentItem.GVar]" :key="item.name">{{item.name}}</el-radio>
          </el-radio-group>
        </div> -->
        <div class="d-center-between mb-3" v-if="isAdmin">
          <!-- <left-text-border class="w-50 mr-2 input-just" leftText="前台/总机" v-model="BasicInfo.hotel_tel"/> -->
          <left-text-border class="w-50 input-just" leftText="携程酒店ID" v-model="BasicInfo.c_hotel_id"/>
          <div class="w-50 ml-2"></div>
        </div>
        <div class="d-center-start mb-3"  >
          <left-text required leftText="早餐类型"/>
            <el-checkbox-group v-model="BasicInfo.breakfast_type" class="d-center-start flex-wrap" @change="changeBreakfastType"> 
              <el-checkbox :label="item.id" :key="item.name" class="mr-3 ml-0"
                          v-for="item in $GVAR.breakfastHotel">{{item.name}}
              </el-checkbox>
            </el-checkbox-group>
        </div>
        <!--当选择了有早餐的时候显示设置早餐时间-->
        <div class="d-center-start mb-3"  v-if="targets(['1','2'])">
          <left-text-timespan class="w-50 mr-4"
                    :leftText="'早餐时间'"
                    v-model="BasicInfo.breakfast_time"
                    placeholder=""
                    type="daterange"
                    />           
        </div>
        <div class="d-start-start mb-3">
          <left-text :leftText="`${storeType}简介`"/>
          <rich-editor class="w-100" v-model="BasicInfo.intro" :contentProps="BasicInfo.intro" :allowUploadImg="storeInfo.type!=3"/>
        </div>
      </div>
       <!--设施标签-->
      <div v-if="HStore===2">
        <div class="label-name mb-3"><p>设施</p></div>
        <div class="d-start-start mb-3" v-for="parentItem in HMutiChooseFeatures" :key="parentItem.leftText">
          <left-text :leftText="parentItem.leftText"/>
          <el-checkbox-group v-model="BasicInfo[parentItem.value]" class="text-left">
            <el-checkbox class="ml-0 mr-2 mb-2" :label="item.id" v-for="item in $GVAR[parentItem.GVar]" :key="item.name">{{item.name}}</el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="label-name mb-3"><p>标签</p></div>
        <div class="d-center-start mb-3" v-if="storeInfo.type != 5">
          <left-text required leftText="酒店星级"/>
          <div class="starRating">
            <p :class="{'classify':!state_star}"  @click="tabstate_star(false)">平台星级</p>
            <p :class="{'classify':state_star}" @click="tabstate_star(true)">评星酒店</p>
          </div>
            <el-radio-group v-model="BasicInfo.star">
              <el-radio :label="item.id" v-for="item in state_star? $GVAR.governmentHotelStar:$GVAR.HotelStar.slice(2,7)" :key="item.name">{{item.name}}</el-radio>
            </el-radio-group>
        </div>
        <div class="d-center-start mb-3" v-for="parentItem in HRequireFeatures" :key="parentItem.leftText">
          <left-text required :leftText="parentItem.leftText"/>
          <el-radio-group v-model="BasicInfo[parentItem.value]" class="lisdq">
            <el-radio :label="item.id" v-for="item in $GVAR[parentItem.GVar]" :key="item.name">{{item.name}}</el-radio>
          </el-radio-group>
        </div>
        <!--主题特色-->
        <div class="d-start-start mb-3" v-for="parentItem in HMutiChooseSubjectType" :key="parentItem.leftText">
          <left-text :leftText="parentItem.leftText"/>
          <el-checkbox-group v-model="BasicInfo[parentItem.value]" class="text-left">
            <el-checkbox class="ml-0 mr-2 mb-2" :label="item.id" v-for="item in $GVAR[parentItem.GVar]" :key="item.name">{{item.name}}</el-checkbox>
          </el-checkbox-group>
        </div>
        <left-text-brand class="mb-3"
            leftText="酒店品牌"                   
            v-model="BasicInfo.brand"
            :options="$GVAR.FacilitiesPlatform"
          />
      </div>
      <!--团队政策-->
      <div v-if="HStore===3">
        <!-- <div class="d-center-start mb-3">
          <left-text :leftText="`相关配套`"/>
          <el-checkbox v-model="BasicInfo.is_meeting">会议室</el-checkbox>
          <el-checkbox v-model="BasicInfo.is_breakfast">有餐饮</el-checkbox>
        </div> -->
        <left-text-radio class="mb-3"
            leftText="酒店资质"                   
            v-model="BasicInfo.recepte"
            :options="$GVAR.receptionAccess"/>
        <div v-if="storeInfo.type != 5">
            <div class="d-start-start mb-2" v-for="parentItem in HOtherChooseFeatures" :key="parentItem.leftText">
              <div class="tiele">
                <span class="text-white div mr-small ">*</span>
                <div>司陪政策</div>
                <span>：</span>
              </div>
              <div class="w-100">
                <el-input v-model="BasicInfo[parentItem.value]"/>
                <div class="mt-2 text-left text-muted">
                  <span class="h6">推荐选择：</span>
                  <el-radio-group v-model="BasicInfo[parentItem.value]">
                    <el-radio :label="item" v-for="item in $GVAR[parentItem.GVar]" :key="item">{{item}}</el-radio>
                  </el-radio-group>
                </div>
              </div>
            </div>
            <div class="d-center-start mb-3" v-for="parentItem in HRequire" :key="parentItem.id">
            <left-text  :leftText="parentItem.leftText"/>
              <el-radio-group v-model="BasicInfo[parentItem.value]">
                <el-radio :label="item.id" v-for="item in $GVAR[parentItem.GVar]" :key="item.id">{{item.name}}</el-radio>
              </el-radio-group>
            </div>
            <left-text-unit class="mb-2"
                              leftText="客房总数"                   
                              v-model="BasicInfo.room_count"
                              unit="间"
                              required
                              />
            <left-text-unit class="mb-2"
                              leftText="双床房总数量"                   
                              v-model="BasicInfo.room_2_count"
                              unit="间"
                              required
                              />
            <left-text-unit class="mb-2"
                              leftText="会议室数量"                   
                              v-model="BasicInfo.meeting_count"
                              unit="个"
                              />
            <left-text-unit class="mb-2"
                              leftText="最大会议室面积"                   
                              v-model="BasicInfo.meeting_area"
                              unit="m"
                              >
                              <span style="margin-right: -4px;">m<sup>2</sup></span>
                              </left-text-unit>
            <div class="d-start-start mb-2">
              <div class="tiele">
                <span class="text-white div mr-small ">*</span>
                <div>团队停车</div>
                <span>：</span>
              </div>
              <div class="w-100">
                <el-input v-model="BasicInfo.parking"/>
                <div class="mt-2 text-left text-muted">
                  <span class="h6">推荐选择：</span>
                  <el-radio-group v-model="BasicInfo.parking">
                    <el-radio :label="item" v-for="item in $GVAR.parkingArr" :key="item">{{item}}</el-radio>
                  </el-radio-group>
                </div>
              </div>
            </div>
            <!-- <left-text-radio2 class="mb-3"
                              leftText="停车场"                   
                              v-model="BasicInfo.parking"
                              :options="$GVAR.parkingArr"
                              /> -->
          </div>
      </div>
      <el-button @click="submitForm" class="mt-4 w-25 btn-login">保存信息</el-button>
    </div>
</template>

<script>
  import { mapGetters,mapState } from 'vuex'
  import RichEditor from '@/components/Editor/RichEditor'
  export default {
    name: 'HStoreBasic',
    components: { RichEditor},
    computed: {
      ...mapState(['StoreBasicInfo']),
      ...mapGetters(['storeInfo','isAdmin','isGroup']),
      storeType() {
        return this.$options.filters['formatVar'](this.storeInfo.type,'StoreType')
      }
    },
    props: {
      HStore: {},
    },
    data () {
      return {
        BasicInfo: {
          service:[],
        },
        breakfast:[
          {leftText:'早餐类型',value:'breakfast_type',GVar:'breakfastTypeArr',id:4},
        ],
        HRequireFeatures:[
          {leftText:'住宿类型',value:'type',GVar:'StyleLabel',id:1},
         
          {leftText:'装修风格',value:'decorate',GVar:'DecorationLabel',id:3},
          // {leftText:'接待资质',value:'recepte',GVar:'receptionAccess',id:3},
        ],
        HOtherChooseFeatures:[
          {leftText:'司陪政策',value:'escort_policy',GVar:'escortPolicyArr',id:0},
          
        ],
        HRequire:[
         {leftText:'最低成团',value:'min_team_num',GVar:'minTeamNumArr',id:0},
        ],
        HMutiChooseFeatures:[
          {leftText:'酒店设施',value:'facility',GVar:'FacilitiesBasic',id:0},
          {leftText:'酒店服务',value:'service',GVar:'Facilitiesflsec',id:1},
        ],
        HMutiChooseSubjectType:[
         {leftText:'主题特色',value:'topic',GVar:'SubjectType',id:2},
        ],
        state_star:false,
      }
    },
    watch: {
      StoreBasicInfo () {
        this.initStoreInfo()
      },
    },
    created () {
      this.initStoreInfo()
    },
    methods:{
      //选择早餐类型
      changeBreakfastType(val){
        const targetUser = val.find(user => user == 4);
        //点击无早只保留无早选项/点击其他删除无早
        if(targetUser&&val[val.length-1]=='4'){
          console.log(targetUser,45678);
          this.BasicInfo.breakfast_type=['4']
        }else{
            const index = val.indexOf('4');
            if (index !== -1) { // 确保元素存在
              this.BasicInfo.breakfast_type.splice(index, 1); // 原地修改，触发响应式更新
            }
        }
      },
      // 自定义判断：检查 date 中是否存在与目标 id 匹配的对象
      targets(date){
        const hasAll = date.some(item => this.BasicInfo.breakfast_type.includes(item));
        return hasAll
      },
      /*门店信息初始化*/
      initStoreInfo() {
        this.BasicInfo = {
          ...this.StoreBasicInfo,
          startdate:this.StoreBasicInfo.startdate == 0 ? '' :this.StoreBasicInfo.startdate * 1000,
          fitmentdate:this.StoreBasicInfo.fitmentdate == 0 ? '' :this.StoreBasicInfo.fitmentdate * 1000,
          star:String(this.StoreBasicInfo.star),
          is_meeting:Boolean(this.StoreBasicInfo.is_meeting*1),
          is_breakfast:Boolean(this.StoreBasicInfo.is_breakfast*1),
          breakfast_type:this.StoreBasicInfo.breakfast_type + '',
          topic:this.StoreBasicInfo.topic&&this.StoreBasicInfo.topic.split(',')||[],
          facility:this.StoreBasicInfo.facility&&this.StoreBasicInfo.facility.split(',')||[],
          service:this.StoreBasicInfo.service&&this.StoreBasicInfo.service.split(',')||[],
          breakfast_type:this.StoreBasicInfo.breakfast_type&&this.StoreBasicInfo.breakfast_type.split(',')||[],
          breakfast_time:(!this.StoreBasicInfo.breakfast_time || this.StoreBasicInfo.breakfast_time == 0) ? "06:00,08:00" :this.StoreBasicInfo.breakfast_time
        };
        if(this.BasicInfo.breakfast_time instanceof Array){
          if(this.BasicInfo.breakfast_time[0] && this.BasicInfo.breakfast_time[0].split(',').length>1 ){
            this.BasicInfo.breakfast_time = this.BasicInfo.breakfast_time[0].split(',')
          }
        }
        //如果是政府星级则赋值给state_star/
        if(this.BasicInfo.state_star>0){
          this.state_star=true;
          //如果是白金酒店则赋值star为6
          if(this.BasicInfo.state_star=='6'){
            this.BasicInfo.star='6';
          }
        }
      },
      /*表单验证，管理员不需要校验必填项*/
      validateForm() {
        if (!this.isAdmin) {
          let valueArr = ['startdate','fitmentdate'];
          if(this.HStore===1){
            valueArr.push('hotel_tel');
          }
          if(this.HStore==2){
            valueArr.push('decorate','star','type');
          }

          if(this.HStore===3){
            valueArr.push('room_count','room_2_count');
          }
          for (let i = 0; i < valueArr.length; i++) {
            let t = valueArr[i];
            if (!this.BasicInfo[t]||this.BasicInfo[t]==='0') return {code:false,msg:'星号为必填项，请检查表单'}
          }
        }
        return {code:true,msg:'验证通过'}
      },
      tabstate_star(e){
        if(this.state_star==e) return;
        this._confirm(e?'是否切换成评星酒店':'是否切换成平台星级'+'?',() => {
          this.state_star = !this.state_star;
          this.BasicInfo.star='';
        })
      },
      submitForm() {
        // if (!this.$GFUN.powerIsInArray([95,363,428,99,234,155,271,370])) { this._alert('您没有相关权限！',null,'error'); return; }
        if (this.BasicInfo.breakfast_type != 0 && !this.BasicInfo.breakfast_time) { this.$message.warning('请选择早餐时间！'); return; }
        let result = this.validateForm();
        console.log(result,767);
        if (result.code) {
          this._confirm('确定提交信息么？',() => {
            let info = {
              ...this.BasicInfo,
              star:Number(this.BasicInfo.star),
              is_meeting:this.BasicInfo.is_meeting ? '1' : '0',
              is_breakfast:this.BasicInfo.is_breakfast ? '1' : '0',
              startdate:this.BasicInfo.startdate / 1000,
              fitmentdate:this.BasicInfo.fitmentdate / 1000,
              topic:this.BasicInfo.topic.join(','),
              facility:this.BasicInfo.facility.join(','),
              service:this.BasicInfo.service.join(','),
              breakfast_type:this.BasicInfo.breakfast_type.join(','),
              breakfast_time:this.BasicInfo.breakfast_type != 0 ? this.BasicInfo.breakfast_time : '',
              state_star:this.state_star ? this.BasicInfo.star : '',          //如果是政府星级则赋值给state_star
              star:this.BasicInfo.star=='6'?'5':this.BasicInfo.star,          //如果是政府星级白金starid变为5
            }
            this.$emit('saveInfo',info)
            
          })
        } else this._alert(result.msg,null,'error');
      }
    }
  }
</script>

<style scoped lang="scss">
.input-just{
  box-sizing: border-box;
  height: 31px!important;
}
.d-center{
  display: flex;
  justify-content: left;
}
.lisdq{
  display: flex;
  justify-content: left;
  flex-wrap: wrap;
}
.tiele{
  display: flex;
  justify-content: flex-start;
  line-height: 40px;
  height: 40px;
}
.tiele div{
  width: 100px;
  text-align: justify;
}
.tiele div:after {
    content: " ";
    display: inline-block;
    width: 100%;
}
.starRating{
  text-align: left;
  display: flex;
  text-align: center;
  margin-bottom: 10px;
  border-radius: 4px;
  overflow: hidden;
  width: 180px;
  line-height: 30px;
  border: 1px #eee solid;
  font-size: 12px;
  margin-top: 5px;
  margin-right: 16px;  
  p{
    width: 100px;
    cursor: pointer;;
  }
  .classify{
    background-color: var(--smtc-color-primary);
    color: #fff;
  }
}
.label-name{
  text-align:left;
  font-weight: bold;
  font-size: 14px;
  padding-left: 12px;
  position: relative;
  p{
    position: relative;
    background-color: #fff;
    z-index: 2;
    width: 50px;
  }
}
.label-name::after {
  content: " ";
  position: absolute;
  top: 2px;
  left: 4px;
  width: 2px;
  height: 18px;
  background-color: var(--smtc-color-primary);
  border-radius: 4px;
}
// .label-name::before {
//   content: " ";
//   position: absolute;
//   top: 12px;
//   right: 0;
//   width: 98%;
//   height: 1px;
//   border-bottom: 1px solid #f5f5f5;
// }
</style>
